import type React from "react";
import {memo} from "react";

import {type IMenuProps, Menu} from "../ui/menu";

export type Props = IMenuProps;

const Dropdown: React.FC<Props> = ({children, testID = "dropdown", ...restProps}) => {
    return (
        <Menu testID={testID} {...restProps}>
            {children}
        </Menu>
    );
};

export default memo(Dropdown);
